/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Total_LabelInputs */

const vi_mobile_total_label = /** @type {(inputs: Mobile_Total_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng tiền`)
};

/**

* @param {Mobile_Total_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const mobile_total_label = /** @type {((inputs?: Mobile_Total_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Total_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_mobile_total_label(inputs)
});